// Move a lightbox selection by `direction` (-1 or +1) without wrapping past
// the ends. Returns the same index when a move would go out of bounds, so the
// first/last images are natural stopping points.
export const nextIndex = (current, direction, total) => {
  const target = current + direction;
  if (target < 0 || target >= total) return current;
  return target;
};
